export const DOCUMENTOS_GUIAS = [
  {
    id: 'guia-sustentante',
    label: 'Guía del sustentante',
    title: 'Guía para el sustentante',
    date: '18 de junio de 2025',
    tag: 'Documento oficial',
    desc: 'La estructura completa del examen: áreas, número de reactivos, temarios, bibliografía de apoyo y ejemplos de reactivos de opción múltiple.',
    url: '/guias/guia-sustentante.pdf',
  },
  {
    id: 'folleto',
    label: 'Folleto EXANI-II',
    title: 'Folleto EXANI-II',
    date: '24 de marzo de 2025',
    tag: 'Folleto informativo',
    desc: 'Información general del Examen Nacional de Ingreso a la Educación Superior: propósito, calificación y recomendaciones para el sustentante.',
    url: '/guias/folleto-exani-ii.pdf',
  },
  {
    id: 'guia-desde-casa',
    label: 'Examen desde casa',
    title: 'Guía de aplicación · Examen desde casa (2026)',
    date: 'Enero de 2026',
    tag: 'Guía de aplicación',
    desc: 'Todo sobre la modalidad desde casa: Navegador Seguro CENEVAL, requisitos del equipo, identificación, examen de práctica y comportamiento ético.',
    url: '/guias/guia-aplicacion-desde-casa.pdf',
  },
  {
    id: 'modalidad-linea',
    label: 'Modalidad en línea',
    title: 'Modalidad de aplicación en línea (presencial)',
    date: 'Junio de 2025',
    tag: 'Guía de aplicación',
    desc: 'Aplicación en sedes institucionales con equipos de cómputo: requisitos de ingreso, material permitido y funcionamiento de la plataforma.',
    url: '/guias/modalidad-en-linea.pdf',
  },
  {
    id: 'modalidad-impresa',
    label: 'Examen impreso',
    title: 'Modalidad de aplicación · Examen impreso',
    date: 'Junio de 2025',
    tag: 'Guía de aplicación',
    desc: 'Aplicación presencial con cuadernillo y hoja de respuestas: requisitos, material permitido e indicaciones para el llenado correcto.',
    url: '/guias/modalidad-impresa.pdf',
  },
];